import script from "./PreviewLinkPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewLinkPopup.vue?vue&type=script&setup=true&lang=js"

import "./PreviewLinkPopup.vue?vue&type=style&index=0&id=1f83219a&lang=scss"

export default script